export const seo = {
  seo: {
    title: 'Wehrfritz » Outfitter for nursery, kindergarten & after-school care',
    description:
      'Leading in kindergarten supplies for over 80 years ✓ Wehrfritz for innovative room concepts & 3D planning ✓ Free on-site consultation » Discover now!',
    productTitle: '{{dynamic}} buy online » Wehrfritz',
    productDescription:
      '{{dynamic}} ► Your complete outfitter for nursery, kindergarten & school ✓ Encourage - educate - experience ✓ Order now!',
    categoryTitle: 'buy online » Wehrfritz',
    categoryDescription:
      'Your complete outfitter for nursery, kindergarten & after-school care ✓ Encourage - educate - experience ✓ Clever in-house products » Now at Wehrfritz!',
  },
};
